import { text as moduleText } from './text';

function errorMessage(error: unknown, fallback: string): string {
  if (error instanceof Error && error.message.trim()) {
    return error.message;
  }
  return fallback;
}

export const text = {
  createErrorMessage(error: unknown): string {
    return errorMessage(error, moduleText.createError);
  },

  updateErrorMessage(error: unknown): string {
    return errorMessage(error, moduleText.updateError);
  },

  deleteErrorMessage(error: unknown): string {
    return errorMessage(error, moduleText.deleteError);
  },
};
